import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

const Fbar = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        {/* Notification Header */}
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">
              FBAR, FATCA, and PFIC Reporting Services
            </h1>
           <Link to="/services" className="tax-notification-body">
  ← Back to Services
</Link>

          </div>
        </div>

        {/* Main Content */}
        <div className="tax-content-container">
          <h1 className="tax-section-title">
            FBAR, FATCA, and PFIC Compliance Made Simple
          </h1>
          <p className="tax-section-description">
            At <strong>Litax </strong>, we recognize how challenging
            international tax compliance can be. If you hold foreign bank
            accounts, investments, or business interests abroad, the IRS
            requires you to disclose them under reporting rules such as FBAR,
            FATCA, and PFIC. These laws carry steep penalties for noncompliance
            — even for innocent mistakes. Our experienced team of Certified
            Public Accountants (CPAs) and Enrolled Agents (EAs) helps you
            navigate these requirements with confidence, ensuring timely and
            accurate reporting.
          </p>

          {/* FBAR Section */}
          <h2 className="tax-subheading">FBAR (Foreign Bank Account Report)</h2>
          <p className="tax-section-description">
            U.S. persons with foreign financial accounts exceeding{" "}
            <strong>$10,000</strong> at any time during the year must file an
            FBAR with the Financial Crimes Enforcement Network (FinCEN).
            Noncompliance can result in penalties of thousands of dollars per
            account.
          </p>

          <h3>Who Must File?</h3>
          <ul className="tax-section-description">
            <li>U.S. citizens, residents, and entities (corporations, trusts, partnerships).</li>
            <li>
              Anyone with financial interest in or signature authority over
              foreign accounts exceeding $10,000 in aggregate value.
            </li>
          </ul>

          <h3>Reportable Accounts Include:</h3>
          <ul className="tax-section-description">
            <li>Foreign bank savings and checking accounts.</li>
            <li>Foreign business accounts under your control.</li>
            <li>Foreign investment accounts or time deposits.</li>
          </ul>

          {/* FATCA Section */}
          <h2 className="tax-subheading">FATCA (Foreign Account Tax Compliance Act)</h2>
          <p className="tax-section-description">
            FATCA requires U.S. taxpayers to disclose foreign financial assets
            on <strong>Form 8938</strong> if they exceed specific thresholds.
            Unlike FBAR, FATCA is filed with your annual tax return.
          </p>

          <h3>Reporting Thresholds:</h3>
          <ul className="tax-section-description">
            <li>
              Single filers: $50,000 on the last day of the year or $75,000 at
              any point.
            </li>
            <li>
              Married filing jointly: $100,000 on the last day of the year or
              $150,000 at any point.
            </li>
          </ul>

          <h3>Examples of Reportable Assets:</h3>
          <ul className="tax-section-description">
            <li>Foreign bank accounts and securities.</li>
            <li>Ownership in foreign partnerships or entities.</li>
            <li>Foreign investment portfolios and bonds.</li>
          </ul>

          {/* PFIC Section */}
          <h2 className="tax-subheading">PFIC (Passive Foreign Investment Company)</h2>
          <p className="tax-section-description">
            PFIC rules apply to foreign corporations where most income is
            passive (dividends, interest, rents) or where at least 50% of assets
            produce passive income. PFIC investments are taxed harshly unless
            reported correctly on <strong>Form 8621</strong>.
          </p>

          <h3>Common PFIC Examples:</h3>
          <ul className="tax-section-description">
            <li>Foreign mutual funds and ETFs.</li>
            <li>Foreign-based investment trusts.</li>
            <li>Overseas real estate holding companies.</li>
          </ul>

          {/* How We Help */}
          <h2 className="tax-subheading">How Litax  Assists You</h2>
          <ul className="tax-section-description">
            <li>
              <strong>FBAR Compliance:</strong> Identify qualifying accounts and
              prepare accurate FinCEN filings.
            </li>
            <li>
              <strong>FATCA Reporting:</strong> Complete Form 8938 and integrate
              it into your tax return with full accuracy.
            </li>
            <li>
              <strong>PFIC Guidance:</strong> Handle complex Form 8621 filings
              while advising you on tax-efficient strategies.
            </li>
            <li>
              <strong>Penalty Prevention:</strong> Ensure timely reporting to
              avoid severe IRS and FinCEN penalties.
            </li>
            <li>
              <strong>Ongoing Support:</strong> Provide year-round guidance for
              expats, business owners, and international investors.
            </li>
          </ul>

          <p className="tax-section-description">
            International tax rules are complex — but you don’t have to face
            them alone. At <strong>Litax </strong>, we simplify the
            process, protect you from penalties, and keep you fully compliant
            with global tax regulations. Contact us today to get expert support
            for your FBAR, FATCA, and PFIC reporting.
          </p>
        </div>
      </div>

      {/* Common Components */}
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Fbar;
